'use strict';

var $ = require('jquery');
var colorbox = require('../lib/plaudit.colorbox.js');

var optionsDefaults = {
	speed: 700,
	transition: 'fade',
	opacity: .75,
	scalePhotos: true,
	closeButton: true,
	maxWidth: '95%',
	maxHeight: '95%',
	initialWidth: 500,
	initialHeight: 300,
	fixed: true,
	current: '',
	next: '\
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60">\
			<path class="ring" fill="rgba(255,255,255,0)" d="M30 2.1c15.4 0 28 12.5 28 27.9S45.4 58 30 58 2.1 45.4 2.1 30 14.6 2.1 30 2.1M30 0C13.4 0 0 13.4 0 30c0 8 3.2 15.6 8.8 21.2 11.7 11.7 30.7 11.7 42.4 0s11.7-30.7 0-42.4C45.6 3.1 38 0 30 0z"> </path>\
			<circle fill="#FFF" cx="29.9" cy="30" r="26.1"> </circle>\
			<circle fill="#004f35" cx="29.9" cy="30" r="23.6"> </circle>\
			<path fill="#FFF" d="M26.9 38.1l7.9-8.3-7.9-8-1.8 1.9 6.1 6.2-6.2 6.4"> </path>\
		</svg>\
		<span>next</span>',
	previous: '\
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" width="60">\
			<path class="ring" fill="rgba(255,255,255,0)" d="M30 2.1c15.4 0 27.9 12.5 27.9 27.9S45.4 58 30 58 2 45.4 2 30 14.6 2.1 30 2.1M8.8 8.8c-11.7 11.7-11.7 30.7 0 42.4s30.7 11.7 42.4 0C56.8 45.6 60 38 60 30 60 13.4 46.6 0 30 0 22 0 14.4 3.1 8.8 8.8z"> </path>\
			<circle fill="#FFF" cx="30.1" cy="30" r="26.1"> </circle>\
			<circle fill="#004f35" cx="30.1" cy="30" r="23.6"> </circle>\
			<path fill="#FFF" d="M35 36.3l-6.2-6.4 6.1-6.2-1.8-1.9-7.9 8 7.9 8.3"> </path>\
		</svg>\
		<span>prev</span>'
}

function initGallery() {
	var $elem = $('.gallery');
	if ($elem.length == 0) {
		return;
	}

	var options = $.extend({}, optionsDefaults, {
		rel: 'gallery',
		className: 'cb--gallery'
	});

	var $images = $('a', $elem);
	$images.colorbox(options);
}

module.exports = {
	init: function(){
		initGallery();
	}
}